import svg from '../assets/logo.svg';

interface Props {
  variant: 'default' | 'negative';
}

export default function Logo({ variant = 'default' }: Partial<Props>) {
  return (
    <div
      style={{
        width: '52px',
        height: '32px',
        maskImage: `url("${svg}")`,
        backgroundColor:
          variant === 'negative'
            ? 'white'
            : 'light-dark(#0c268f, var(--mantine-color-blue-4))',
      }}
    />
  );
}
